import { Divider, ListItemIcon, ListItemText, ListItem } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { $darkGray } from 'constants/styles';
import { handleRoute } from 'utils/helpers';
import { useSelector } from 'react-redux';
import {
	userAccountsSelector,
	accountDataSelector,
	currentUserSelector
} from 'reducers/userAuthSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const UserMenuContent = ({ handleClose }) => {
	const styles = {
		currentAccount: {
			opacity: '1.0 !important',
			color: $darkGray,
			paddingLeft: '5px'
		},
		listItemIcon: {
			display: 'flex',
			justifyContent: 'center'
		}
	};
	const { t } = useTranslation();
	const navigate = useNavigate();
	const accountData = useSelector(accountDataSelector);
	const accounts = useSelector(userAccountsSelector);
	const currentUser = useSelector(currentUserSelector);

	const renderSwitchAccount = () => {
		if (accounts && accounts.length > 1)
			return (
				<ListItem button onClick={() => navigate('/account-picker')} sx={styles.listItem}>
					<ListItemText>{t('Switch Account')}</ListItemText>
				</ListItem>
			);
	};

	const handleGoToUserProfile = () => {
		handleRoute(`manage/users?id=${currentUser.id}`, navigate);
		if (handleClose) {
			handleClose();
		}
	};

	return (
		<>
			<ListItem button disabled sx={styles.currentAccount}>
				<ListItemIcon sx={styles.listItemIcon}>
					<GroupIcon style={styles.icon} />
				</ListItemIcon>
				<ListItemText>{accountData?.account_name}</ListItemText>
			</ListItem>
			<Divider />
			{renderSwitchAccount()}
			<ListItem button onClick={handleGoToUserProfile}>
				<ListItemText>{t('Profile')}</ListItemText>
			</ListItem>
			<ListItem button onClick={() => navigate('/logout')}>
				<ListItemText>{t('Logout')}</ListItemText>
			</ListItem>
		</>
	);
};

export default UserMenuContent;
